export const MIN_QUERY_LENGTH = 2;

export const QUESTION_PREFIXES = [
  'who',
  'what',
  'when',
  'where',
  'why',
  'how many',
  'how much',
  'how',
];

export const COMMAND_PREFIXES = [
  'show me',
  'tell me',
  'find me',
  'give me',
  'list',
  'count',
  'create',
];

export const isQuestion = (query: string): boolean => {
  if (query.length < MIN_QUERY_LENGTH) return false;

  const trimmed = query.trimStart().toLowerCase();

  if (trimmed.endsWith('?')) return true;

  for (const prefix of QUESTION_PREFIXES) {
    if (trimmed.startsWith(`${prefix} `) || trimmed === prefix) return true;
  }

  for (const prefix of COMMAND_PREFIXES) {
    if (trimmed.startsWith(`${prefix} `)) return true;
  }

  return false;
};
